export default __webpack_public_path__ + "static/media/dinosound-logo.9e2119b3.svg";